type LinkType = {
  name: string;
};
const links: LinkType[] = [{ name: "home" }, { name: "products" }, { name: "todo" }, { name: "about" }, { name: "contact" }];

export { links, LinkType };
